import { render, staticRenderFns } from "./UserValidSettingDelete.vue?vue&type=template&id=2dd7076a&"
import script from "./UserValidSettingDelete.vue?vue&type=script&lang=js&"
export * from "./UserValidSettingDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports